/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class UpdateGraphTitleService extends BaseService {
  constructor() {
    super(constants.UPDATE_GRAPH_TITLE, 'updateGraphTitleStatus');
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { graphId, version, graphName } = payload;

    const url = `/graphs/${graphId}${version ? `?version=${version}` : ''}`;
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').patch(url, { graphName }, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').patch(url, { graphName }, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    const notification = {
      open: true,
      type: 'success',
      message: data?.message || 'Graph title updated successfully!'
    };
    Framework.getStoreRegistry().getStore('notificationState').set(notification);
    Framework.getEventManager().publish(constants.UPDATE_GRAPH_TITLE_SUCCESS, { data });
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      const errorMessage =
        response?.data?.message || error?.message || 'Failed to update graph title. Please try again.';
      const notification = {
        open: true,
        message: errorMessage,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: 'Request timeout. Please try again.',
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getEventManager().publish(constants.UPDATE_GRAPH_TITLE_ERROR, { error });
  }
}
